
import mqtt from "mqtt";
// import Vue from 'vue'

// var vm = new Vue();

class mqttHandle {
    constructor(subscribe,loginuser) {
        this.connect = {
            // host: "121.37.175.58",
            // port: 8701,
            // endpoint: "mqtt",
            clean: true, // 保留会话
            cleanSession: true,
            connectTimeout: 60000, // 超时时间
            reconnectPeriod: 30000, // 重连时间间隔
            // 认证信息
            clientId: "screen-channel-"+loginuser+"-"+Number(new Date()).toString(),
            username: "admin",
            password: "airoboy123",
        }
        this.subscription = {
            topic: subscribe,  //需要传入数组的包含订阅的名称
            qos: 0,
        }
        this.mqttClient = null;
    }
    /**
     * 创建链接
     * @returns client
     */
    createConnect() {
        //配置链接
        const { host, port, endpoint, ...options } = this.connect;
        // const connectUrl = `wss://${this.connect.host}:${this.connect.port}/${this.connect.endpoint}`;	
		const connectUrl = 'wss://mqtt.techinao.com/mqtt';//2025-10-11改成安全访问，Gpn
		console.log("MQTT连接地址",connectUrl);
		// const connectUrl = 'ws://121.37.175.58:8700/mqtt'	
        try {
            this._client = mqtt.connect(connectUrl, options);
			console.log("MQTT连接成功");
        } catch (error) {
            console.log("mqtt connect error", error);
        }
        this._client.on("connect", () => {
            console.log("MQTT Connection succeeded!");
        });
        this._client.on('reconnect', (error) => {
            console.log('MQTT 正在重连', error)
        })
        this._client.on("error", (error) => {
            console.log("MQTT Connection failed", error);
        });
 
        //配置topic
        const { topic, qos } = this.subscription;
        this._client.subscribe(topic, { qos: qos }, (error, res) => {
            if (error) {
                console.log("MQTT Subscribe to topics error", error);
                return;
            }
            this.subscribeSuccess = true;
            console.log("MQTT Subscribe to topics res", res[0].qos+"-"+res[0].topic, res[1].qos+"-"+res[1].topic);
        });
        this.mqttClient = this._client;
        return this.mqttClient;
    }
}
 
export default mqttHandle;